import React from 'react';

import { TextProps } from '@/components/TextComponent';
import { useComboOdds, usePreviousComboOdds } from '@/feature/betslip-sbk/hooks/betslip-hooks';
import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { hasComboOddsChangedSelector } from '@/feature/betslip-sbk/utils/betslip-selectors';
import { BetIds } from '@/feature/betslip-sbk/utils/betslip-utils';

import { BetSlipOdds } from '../BetSlipOdds';

export const ParlayOdds = (props: TextProps) => {
    const odds = useComboOdds();
    const previousOdds = usePreviousComboOdds();
    const hasOddsChanged = useSbkBetSlipStore(hasComboOddsChangedSelector);
    const betId = BetIds.COMBO;
    return <BetSlipOdds {...{ odds, betId, previousOdds, hasOddsChanged }} {...props} />;
};
